
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-refresh-line',
      title: 'Sản Phẩm Liên Tục Cập Nhật',
      description: 'Luôn có sản phẩm mới, đa dạng để phục vụ khách hàng'
    },
    {
      icon: 'ri-presentation-line',
      title: 'Training 1-1 & Theo Nhóm',
      description: 'Đào tạo chuyên sâu kỹ năng bán tour Mỹ hiệu quả'
    },
    {
      icon: 'ri-image-line',
      title: 'Full Bộ Media Chất Lượng',
      description: 'Hình ảnh, video, poster chuyên nghiệp sẵn sàng sử dụng'
    },
    {
      icon: 'ri-palette-line',
      title: 'Thiết Kế Ấn Phẩm',
      description: 'Hỗ trợ thiết kế brochure, banner, catalog chuyên nghiệp'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Hỗ Trợ Chốt Đơn',
      description: 'Tư vấn khách hàng, hỗ trợ chốt sale khi cần thiết'
    },
    {
      icon: 'ri-star-line',
      title: 'Ưu Tiên Đặt Dịch Vụ',
      description: 'Ưu tiên đặt dịch vụ tại Mỹ với giá tốt nhất'
    },
    {
      icon: 'ri-award-line',
      title: 'Co-Branding Thương Hiệu',
      description: 'Đồng thương hiệu, nâng cao uy tín doanh nghiệp'
    },
    {
      icon: 'ri-flight-takeoff-line',
      title: 'Famtrip & Roadtrip Hàng Quý',
      description: 'Tham gia khảo sát thực địa Mỹ hàng quý'
    }
  ];

  return (
    <section id="benefits" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
            Quyền Lợi Tất Cả Đại Lý
          </h2>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-600 to-blue-400 mx-auto mb-6 sm:mb-8"></div>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto px-4">
            Hệ thống quyền lợi toàn diện giúp đại lý phát triển bền vững và hiệu quả
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-10 sm:mb-12">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 text-center"
            >
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-blue-500 to-blue-600 rounded-full mx-auto mb-4 sm:mb-6 shadow-lg">
                <i className={`${benefit.icon} text-white text-2xl sm:text-3xl`}></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3">{benefit.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center px-4">
          <a 
            href="#strategies"
            className="inline-block w-full sm:w-auto px-6 sm:px-8 md:px-10 py-4 sm:py-5 bg-blue-600 text-white text-sm sm:text-base md:text-lg font-bold rounded-full hover:bg-blue-700 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Xem Quyền Lợi Chi Tiết
          </a>
        </div>
      </div>
    </section>
  );
}
